import { render, staticRenderFns } from "./trialDetailList.vue?vue&type=template&id=0b7035d8&scoped=true&"
import script from "./trialDetailList.vue?vue&type=script&lang=js&"
export * from "./trialDetailList.vue?vue&type=script&lang=js&"
import style0 from "./trialDetailList.vue?vue&type=style&index=0&id=0b7035d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7035d8",
  null
  
)

export default component.exports